<!-- 座席種別・指定方法選択 -->
<template>
  <div>
    <TemplateMfittBooking3 />
  </div>
</template>

<script>
import TemplateMfittBooking3 from "@/views/Templates/MFITT/TemplateMfittBooking3";
export default {
  name: "MfittBooking3",
  components: {
    TemplateMfittBooking3,
  },
  setup() {},
};
</script>
